import { IAVISampleDetails } from "../../models/AVISampleDetails";
import { IAVISamplesAndTests } from "../../models/AVISamplesAndTests";
import { IlabAVIPreference } from "../../models/AVIPreference";
import { IChooseApp } from "../../models/ChooseApp";
import { IFilerInformation } from "../../models/FilerInformation";
import { IPersonalInfo } from "../../models/PersonalInfo";

export interface IAVIRequest {
  labAVIPersonalInfoDetail: IPersonalInfo;
  labAVIChooseApplDetails: IChooseApp;
  labAVISampleTests: IAVISamplesAndTests[];
  labAVIApplDetails: IAVISampleDetails;
  labAVIPreference: IlabAVIPreference;
  labApplicationchangedDetails?: IAVISampleDetails;
  labChangedPreference?: IlabAVIPreference;
  labchangedSampleTestDetails?: IAVISamplesAndTests[];
  labAVIFilerInfoDetails: IFilerInformation;
  actionStatus?: string;
  submittedFeedback?: number;
  isReportGenerated?: number;
  applicationNumber?: string;
  reasonForCancellation?: string;
  labAVIApplicationStatus?: IAVIApplicationStatus;
  labReportDetails?: string;
}

export interface IAVIApplicationStatus {
  applicationRequestFor: number;
  miiApplication: number;
  eserviceApplication: number;
  islabapplicationamended?: number;
  islabapplicationcancelled?: number;
  islabapplicationDuplicated?: number;
  actionedStatus?: string;
  ActionRequest: string;
  amendmentRaisedStage?: number | null;
}

export const defAVIAmmendAppStatus: IAVIApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 18,
  eserviceApplication: 14,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};

export const defAVIAmmendRowAppStatus: IAVIApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 30,
  eserviceApplication: 20,
  islabapplicationamended: 1,
  ActionRequest: "Amendment request",
};
export const defAVICancelAppStatus: IAVIApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 25,
  eserviceApplication: 17,
  islabapplicationcancelled: 1,
  ActionRequest: "Cancel request",
};
export const defAVIAppStatus: IAVIApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};
export const defAVIExchangeAppStatus: IAVIApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 2,
  eserviceApplication: 2,
  ActionRequest: "Application Submitted",
};
export const defAVIPostStatus: IAVIApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 1,
  eserviceApplication: 1,
  ActionRequest: "Application Submitted",
};
export const defDuplicateAppStatus: IAVIApplicationStatus = {
  applicationRequestFor: 2,
  miiApplication: 31,
  eserviceApplication: 21,
  islabapplicationDuplicated: 1,
  ActionRequest: "Duplicate request",
};
